import { useLayoutEffect, useState } from 'react';

const DS_BREAKPOINTS = {
  mobile: 480,
  tablet: 834,
  desktop: 1024,
} as const;

const mediaQuery = {
  mobile: `(max-width: ${DS_BREAKPOINTS.tablet - 1}px)`,
  tablet: `(min-width: ${DS_BREAKPOINTS.tablet}px) and (max-width: ${
    DS_BREAKPOINTS.desktop - 1
  }px)`,
  desktop: `(min-width: ${DS_BREAKPOINTS.desktop}px)`,
};

const detectDevice = () => {
  const ua = navigator.userAgent.toLowerCase();
  const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // iPad 13+ отдаёт Mac UA, но у него touch и нет hover
  const iosDevice =
    /iphone|ipad|ipod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const phone = /iphone|ipod|android.*mobile|windows phone/.test(ua);

  // Планшет = touch-устройство, но не телефон
  const tablet =
    (touch && !phone) ||
    /ipad|tablet|android(?!.*mobile)/.test(ua) ||
    iosDevice;

  return { touch, phone, tablet };
};

type ResponsiveState = {
  viewport: {
    mobile: boolean;
    tablet: boolean;
    desktop: boolean;
  };
  device: {
    touch: boolean;
    phone: boolean;
    tablet: boolean;
  };
};

export const useResponsive = () => {
  const [state, setState] = useState<ResponsiveState>(() => ({
    viewport: {
      mobile: false,
      tablet: false,
      desktop: false,
    },
    device: {
      touch: false,
      phone: false,
      tablet: false,
    },
  }));

  useLayoutEffect(() => {
    const mql = {
      mobile: window.matchMedia(mediaQuery.mobile),
      tablet: window.matchMedia(mediaQuery.tablet),
      desktop: window.matchMedia(mediaQuery.desktop),
    };
    const device = detectDevice();

    const update = () => {
      setState({
        viewport: {
          mobile: mql.mobile.matches,
          tablet: mql.tablet.matches,
          desktop: mql.desktop.matches,
        },
        device,
      });
    };

    update();

    const dispose = Object.values(mql).map((mq) => {
      mq.addEventListener('change', update);

      return () => mq.removeEventListener('change', update);
    });

    return () => dispose.forEach((f) => f());
  }, []);

  return state;
};
